export default "__VITE_ASSET__BbPIRjtw__"